export const Strings = {
  nav: {
    carzy: {
      ja: 'CARZY',
      en: 'CARZY',
    },
    subTitle: {
      ja: 'コレクタブルカーの個人間売買',
      en: 'Buy/sell collectible cars',
    },
    about: {
      ja: 'CARZYとは',
      en: 'ABOUT CARZY',
    },
    aboutCarzy: {
      ja: 'CARZYとは / 出品購入の流れ',
      en: 'ABOUT CARZY',
    },
    crew: {
      ja: '取材クルー',
      en: 'CZ CREW',
    },
    stockList: {
      ja: '車両在庫',
      en: 'STOCK LIST',
    },
    selling: {
      ja: '車両出品',
      en: 'SELLING',
    },
    register: {
      ja: '会員登録',
      en: 'Start by Registering',
    },
    photo: {
      ja: '主催イベントレポート',
      en: 'PHOTO',
    },
    magazine: {
      ja: 'CARZY WEBマガジン',
      en: 'Magazine',
    },
    contact: {
      ja: 'お問い合わせ',
      en: 'INQUIRY',
    },
    company: {
      ja: '会社概要',
      en: 'COMPANY PROFILE',
    },
    terms: {
      ja: '特定商取引法',
      en: 'Terms of services',
    },
    recruit: {
      ja: '採用情報',
      en: 'Recruit',
    },
    privacyPolicy: {
      ja: 'プライバシーポリシー',
      en: 'PRIVACY POLICY',
    }
  },
  appDownload: {
    description1: {
      ja: 'CARZYアプリダウンロード',
      en: 'CARZY APP',
    },
    description2: {
      ja: 'CARZYアプリの利用は無料！まずはお試しください。',
      en: 'The usage fee is free.',
    },
    description3: {
      ja: '会員登録はアプリ内よりお願いします。',
      en: '',
    },
    iOSDownload: {
      ja: 'iOSアプリダウンロード',
      en: 'Download on the App Store',
    },
    androidDownload: {
      ja: 'Androidアプリダウンロード',
      en: '',
    },
  },
  inquiry: {
    description: {
      ja: `ご不明な点やご質問がございましたら、お気軽にお問い合わせください。`,
      en: `CONTACT`,
    },
    name: {
      ja: '名前',
      en: 'Name',
    },
    email: {
      ja: 'メールアドレス',
      en: 'Email',
    },
    contents: {
      ja: 'お問い合わせ内容',
      en: 'Question contents',
    },
    emailError: {
      ja: 'メールアドレスを正しく入力してください。',
      en: 'Please enter your email address using English letters/numbers.',
    },
    completedMessage: {
      ja: 'お問い合わせありがとうございました。',
      en: `We thank you in advance for your patience as you wait for us to reply to your inquiry.
      Our staff will reply to you as soon as possible (generally within a few business days).`,
    },
    submit: {
      ja: '送信する',
      en: 'Submit',
    },
    contactUs: {
      ja: 'お問い合わせ',
      en: 'Contact us',
    },
  },
  breadcrumb: {
    home: {
      ja: 'HOME',
      en: 'HOME',
    },
    carList: {
      ja: '販売車両一覧',
      en: 'Stock List',
    },
  },
  carList: {
    title: {
      ja: '$1$2車両一覧$3 | CARZY',
      en: '$1$2Stock List$3 | CARZY',
    },
    brandSuffix: {
      ja: '',
      en: ' - ',
    },
    sellingPrefix: {
      ja: '販売中の',
      en: 'For Sale - ',
    },
    publishedPrefix: {
      ja: '掲載中の',
      en: '',
    },
    metaDescription: {
      ja: '$2$1車両一覧$3です。中古車サイトにはないようなコレクタブルカーばかり、車を探すだけでも楽しいのがCARZYです。',
      en: '$1$2Collectible cars $3',
    },
    sellingDescriptionPrefix: {
      ja: '販売中の',
      en: 'For sale - ',
    },
    publishDescriptionPrefix: {
      ja: '掲載中の',
      en: '',
    },
    pageTitle: {
      ja: 'CARZYで販売中の車両一覧',
      en: 'STOCK LIST',
    },
    pageBrandTitle: {
      ja: '%s - CARZYで販売中の車両一覧',
      en: '%s - STOCK LIST',
    },
    totalCountSuffix: {
      ja: '台',
      en: ' results',
    },
    sortForSale: {
      ja: '販売中のみ表示',
      en: 'For Sale',
    },
    sortShowAll: {
      ja: 'Sold Outを含む',
      en: 'All Cars',
    },
    sortMaker: {
      ja: 'メーカー',
      en: 'Make',
    },
    sortMakerAll: {
      ja: '全てのメーカー',
      en: 'Any Make',
    },
    next: {
      ja: '次',
      en: 'Next',
    },
    previous: {
      ja: '前',
      en: 'Prev.',
    },
  },
  carDetail: {
    title: {
      ja: '車両詳細 | CARZY',
      en: 'Car Information | CARZY',
    },
    underConstruction: {
      ja: 'Under construction',
      en: 'Under construction',
    },
    inquiryButtonLabel: {
      ja: 'メール問合せ',
      en: 'Contact Us',
    },
    supportTelDesc: {
      ja: 'お気軽に問合せ下さい',
      en: '',
    },
    supportTelNumber: {
      ja: '0120-933-395',
      en: '',
    }
  },
  carSpec: {
    specTitle: {
      ja: '車両スペック',
      en: 'Vehicle Specifications',
    },
    modelYear: {
      ja: '年式',
      en: 'Model Year',
    },
    modelYearSuffix: {
      ja: '年',
      en: '',
    },
    firstYear: {
      ja: '初年度',
      en: 'Year of Purchase',
    },
    displacement: {
      ja: '排気量',
      en: 'Engine Capacity',
    },
    distance: {
      ja: '走行距離',
      en: 'Mileage',
    },
    manualTransmission: {
      ja: 'ミッション',
      en: 'Transmission',
    },
    steeringWheel: {
      ja: 'ハンドル',
      en: 'Steering Wheel',
    },
    color: {
      ja: 'カラー',
      en: 'Color',
    },
    chassisNumber: {
      ja: 'シャーシーNo',
      en: 'Chassis No.',
    },
    engineNumber: {
      ja: 'エンジンNo',
      en: 'Engine No.',
    },
    vehicleInspection: {
      ja: '車検',
      en: 'Inspection',
    },
    area: {
      ja: '出品地域',
      en: 'Area',
    },
  },
  car: {
    modelYear: {
      ja: '年式',
      en: '',
    },
    inStock: {
      ja: '在庫あり',
      en: 'In stock',
    }
  },
  carPrice: {
    currentOfferLabel1: {
      ja: '現在の',
      en: 'Current ',
    },
    currentOfferLabel2: {
      ja: 'オファー',
      en: 'Offer',
    },
    priceSuffixJPY: {
      ja: '万円',
      en: '',
    },
    rangeSymbol: {
      ja: '～',
      en: '-',
    },
    totalPricePrefix: {
      ja: '成約手数料込',
      en: '',
    },
    totalPriceSuffix: {
      ja: '',
      en: 'Transaction Fee Included',
    },
  },
  notFound: {
    description1: {
      ja: '申し訳ございません。指定されたページは削除されたか、名前が変更されたか、一時的に利用できない可能性があります。 次のことをお試し下さい。',
      en: '',
    },
    description2: {
      ja: 'ページアドレス(URL)を正しく入力したか確認する。',
      en: '',
    },
    description3: {
      ja: '更新ボタンをクリックして、再度読み込みを行ってみる。',
      en: '',
    },
    rankingTitle: {
      ja: '他の注目車両',
      en: 'CZ RANKING',
    }
  },
  ServerError: {
    ServiceUnavailable: {
      ja: '申し訳ございません。只今、一時的にご覧いただけません。',
      en: '503 Service Unavailable'
    }
  }
};
